module.exports = __webpack_public_path__ + "static/media/joz_thumb_even.7f4f81de.webp";